import preloaderImg from '../../../svg/dot-preloader-dark.svg';
import { FaRegWindowClose } from 'react-icons/fa';
import ReactQuill from 'react-quill';

import styled from 'styled-components';

export const SFaRegWindowClose = styled(FaRegWindowClose)`
  font-size: 35px;
  margin-left: 5px;
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    color: rgb(255, 100, 46);
  }
`;

export const Arrows = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
  margin-left: 10px;
  color: #999;
`;

export const SInput = styled.input`
  width: 100%;
  border: 1px solid #fff;
  background: transparent;
  padding: 5px 10px;
  cursor: pointer;
  &:focus {
    background: #fff;
    border: 1px dashed #999;
    outline: none;
  }
  &:hover {
    cursor: text;
  }
`;

export const TaskWrapper = styled.div<{ isTracking: boolean; isDetailsVisible: boolean }>`
  position: ${(props) => (props.isTracking ? 'fixed' : 'relative')};
  z-index: ${(props) => (props.isTracking || props.isDetailsVisible ? 999 : 1)};
  top: ${(props) => (props.isTracking ? '38px' : 'auto')};
  left: ${(props) => (props.isTracking ? '10px' : 'auto')};
  width: ${(props) => (props.isTracking ? 'calc(100% - 40px)' : 'auto')};
  height: ${(props) => (props.isTracking ? '57px' : 'auto')};
  background: ${(props) => (props.isTracking ? '#fff' : 'transparent')};
  box-shadow: ${(props) => (props.isTracking ? '0 0 22px 0 rgba(0, 0, 0, 0.5)' : 'none')};
  align-items: ${(props) => (props.isTracking ? 'center' : 'inherit')};
  padding: ${(props) => (props.isTracking ? '0 10px' : '0')};
  transition: 0.3s ease-in-out;
  select {
    height: ${(props) => (props.isTracking ? '40px' : 'auto')};
  }
  button {
    height: 35px;
  }
  display: flex;
  margin-bottom: 1px;
  &:hover {
    background: #f1f1f1;
  }
  #hidden {
    position: absolute;
    opacity: 0;
  }
  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    transition: ease-in-out 0.5s;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }
`;

export const SButton = styled.button`
  border: 1px solid #fff;
  color: #999;
  border-radius: 3px;
  background: #fff;
  &:hover {
    color: #000;
  }
`;

export const Sselect = styled.select<{ background: string }>`
  min-width: 200px;
  background: ${(props) => props.background};
  color: #fff;
  cursor: pointer;
  border: none;
  box-shadow: none;
  padding: 0 5px;
  &:focus {
    outline: none;
  }
`;

export const InputWrapper = styled.div`
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
`;

export const CategoryList = styled.div`
  position: absolute;
  right: 20px;
  margin-top: 50px;
  min-width: 134px;
  border: 1px solid #999;
  border-bottom: none;
  z-index: 2;
  div {
    border-bottom: 1px solid #999;
    background: #fff;
    padding: 5px;
    cursor: pointer;
    transition: ease-in-out 0.3s;
    &:hover {
      background: #f1f1f1;
    }
  }
`;

export const Controls = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const BoardsPreloader = styled.div`
  width: 100%;
  background-image: url(${preloaderImg});
  background-position: center center;
  background-repeat: no-repeat;
  height: 200px;
  top: 0;
  left: 0;
  background-size: 40px;
`;

export const Wrapper = styled.div<{ isDetailsVisible: boolean }>`
  position: fixed;
  height: calc(100vh - 30px);
  overflow: auto;
  width: ${(props) => (props.isDetailsVisible ? '80%' : '0')};
  background: #fff;
  border-left: 1px solid #999;
  right: 0;
  top: 0;
  transition: 0.1s;
  z-index: 999;
  padding: ${(props) => (props.isDetailsVisible ? '20px' : '0')};
  label {
    background: rgb(239, 239, 239);
    font-size: 14px;
    display: inline-block;
    padding: 10px 15px;
    border: 1px solid #fff;
    &:hover {
      border: 1px solid #999;
    }
  }
`;

export const STextArea = styled.textarea<{ isEditing: boolean; height: number }>`
  width: 100%;
  margin: 10px 0;
  min-height: 150px;
  height: ${(props) => props.height}px;
  border: 1px dashed #999;
  resize: ${(props) => (!props.isEditing ? 'none' : 'vertival')};
  &:disabled {
    border: 1px solid #fff;
  }
  &:focus {
    outline: none;
  }
`;

export const Title = styled.div`
  text-align: left;
  font-size: 20px;
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
`;

export const StartPause = styled.button`
  margin-left: 5px;
  white-space: nowrap;
  position: relative;
`;

export const Main = styled.div`
  display: block;
`;

export const SForm = styled.form`
  width: 100%;
  margin: 10px 0 20px;
  input {
    width: 100%;
    margin: 10px 0;
    border: none;
    border-bottom: 1px dashed #999;
    padding: 5px 0;
    &:focus {
      outline: none;
    }
  }
`;

export const SReactQuill = styled<any>(ReactQuill)`
  margin-bottom: 10px;
  position: relative;
  img {
    width: 300px;
  }
  &::after {
    display: ${(props) => (props.isEditing ? 'none' : 'block')};
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(255, 255, 255, 0);
  }
`;

export const Mask = styled.div`
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  display: flex;
  transition: 0.3s ease-in-out;
  z-index: 998;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  color: #fff;
  font-size: 200px;
  align-items: center;
  justify-content: center;
`;

export const ButtonWrapper = styled.div<{ isMyBoard?: boolean }>`
  position: relative;
  &:hover {
    .tooltip {
      display: block;
      padding: 5px;
      border-radius: 3px;
      position: absolute;
      top: ${(props) => (props.isMyBoard ? '-150px' : '-65px')};
      left: ${(props) => (props.isMyBoard ? '0' : '-214px')};
      right: 0;
      margin: auto;
      width: 100%;
      background: rgba(0, 0, 0, 0.8);
      color: #fff;
      text-align: center;
      z-index: 9999999;
      a {
        color: #fff;
        margin: 5px 0px;
        padding: 4px 0;
        line-height: 17px;
        transition: 0.3s ease-in-out;
        background-image: linear-gradient(
          to right,
          rgb(31, 162, 255) 0%,
          rgb(18, 216, 250) 51%,
          rgb(31, 162, 255) 100%
        );
        color: #fff;
        background-size: 200%;
        display: flex;
        text-decoration: none;
        img {
          width: 25px;
        }
        &:hover {
          background-position: right center;
        }
      }
    }
  }
  .tooltip {
    display: none;
  }
`;
